// extracted by mini-css-extract-plugin
export default {"otp-group":"OtpInput_otp-group__UjQPX","otp-input":"OtpInput_otp-input__yfpQu"};